var map = {
	"./comment1.png": 533,
	"./comment10.png": 4248,
	"./comment11.png": 1178,
	"./comment2.png": 9688,
	"./comment3.png": 4301,
	"./comment4.png": 2496,
	"./comment5.png": 8255,
	"./comment6.png": 927,
	"./comment7.png": 3715,
	"./comment8.png": 3667,
	"./comment9.png": 171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2349;